import {
  Avatar,
  Box,
  Stack,
  Typography,
  IconButton,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import usePopover from "../../../../hooks/usePopover";
import { AccountPopover } from "./components/AccountPopover";
import { AuthContext } from "../../../../contexts/AuthContext";
import { useContext } from "react";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
const Index = ({
  setDrawerOpen,
  drawerOpen,
}: {
  setDrawerOpen: (open: boolean) => void;
  drawerOpen: boolean;
}) => {
  const accountPopover = usePopover();
  const { userData } = useContext(AuthContext);
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  const handleDrawer = () => {
    const newDrawerState = !drawerOpen;

    setDrawerOpen(newDrawerState);
    localStorage.setItem("drawerOpen", newDrawerState.toString());
  };

  return (
    <>
      <Box
        component="header"
        sx={{
          backdropFilter: "blur(6px)",
          backgroundColor: "#ffffff",
          position: "sticky",
          width: "100%",
          left: {
            lg: `200px`,
          },
          top: 0,
          zIndex: (theme) => theme.zIndex.appBar,
          borderBottom: "1px solid #f4f7f9",
        }}
      >
        <Stack
          alignItems="center"
          direction="row"
          justifyContent="space-between"
          spacing={2}
          sx={{
            minHeight: 60,
            px: 2,
          }}
        >
          {isDesktop && (
            <IconButton
              onClick={handleDrawer}
              sx={{
                transition: theme.transitions.create("transform", {
                  duration: 1000,
                }),
                transform: drawerOpen ? "rotate(-180deg)" : "rotate(0deg)",
              }}
            >
              <ChevronRightIcon sx={{ marginX: -1 }} />
              <ChevronRightIcon sx={{ marginX: -1 }} />
            </IconButton>
          )}

          <Stack alignItems="center" direction="row" spacing={2}>
            <Typography
              variant="h6"
              sx={{
                color: "#707487",
                textTransform: "uppercase",
              }}
            >
              Magazzino {userData?.user?.warehouse?.name}
            </Typography>
          </Stack>

          <Stack alignItems="center" direction="row" spacing={2}>
            <Avatar
              onClick={accountPopover.handleOpen}
              ref={accountPopover.anchorRef}
              sx={{
                cursor: "pointer",
                height: 42,
                width: 42,
              }}
              src="/assets/logo/nero.png"
            />
          </Stack>
        </Stack>
      </Box>
      <AccountPopover
        anchorEl={accountPopover.anchorRef.current}
        open={accountPopover.open}
        onClose={accountPopover.handleClose}
      />
    </>
  );
};

export default Index;
